/* eslint-disable no-undef */
import React from 'react';
import './MainSteps.sass';

const MainSteps = () => (
  <div className="container">
    <div className="steps bordered-section">
      <h2 className="bold orange">{I18n.t('generic.three_simple_steps')}</h2>
      <div className="row">
        <div className="cols-12 col-sm-4">
          <div className="steps__step steps__step-one">
            1.
            {I18n.t('generic.search_your_office')}
          </div>
        </div>
        <div className="cols-12 col-sm-4">
          <div className="steps__step steps__step-two">
            2.
            {I18n.t('generic.select_offices')}
          </div>
        </div>
        <div className="cols-12 col-sm-4">
          <div className="steps__step steps__step-three">
            3.
            {I18n.t('generic.receive_information')}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default MainSteps;
